import { type RtkQueryLayers } from '../../core';
import { usersOGService } from './users.og';

export const usersRTKQueryLayers: RtkQueryLayers = {
  reducers: {
    providerUserState: usersOGService.reducer,
  },
  middlewares: [usersOGService.middleware],
};
